<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.status" clearable placeholder="状态" @change="list">
            <el-option label="启用" value="0" />
            <el-option label="禁用" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list"> 查询 </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd"> 新增 </el-button>
        </el-form-item>
        <el-form-item>
          <el-button :loading="recalcLoading" @click="handleRecalc"> 按积分重算等级 </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
      >
        <el-table-column prop="id" label="编号" width="80" />
        <el-table-column prop="level" label="等级" width="80" />
        <el-table-column prop="needScore" label="所需积分" width="120" />
        <el-table-column prop="title" label="称号（可选）">
          <template slot-scope="scope">
            {{ scope.row.title || "—" }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            {{ scope.row.status === 0 ? "启用" : "禁用" }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.updateTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)"> 编辑 </el-button>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty />
        </template>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <el-dialog :visible.sync="addFormVisible" :close-on-click-modal="false" title="新增等级">
      <el-form ref="addForm" :model="addForm" label-width="100px">
        <el-form-item label="等级">
          <el-input-number v-model="addForm.level" :min="1" :step="1" />
        </el-form-item>
        <el-form-item label="所需积分">
          <el-input-number v-model="addForm.needScore" :min="0" :step="10" />
        </el-form-item>
        <el-form-item label="称号">
          <el-input v-model="addForm.title" placeholder="可选，前台默认只展示 Lv.n" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="addForm.status" placeholder="请选择">
            <el-option :value="0" label="启用" />
            <el-option :value="1" label="禁用" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false"> 取消 </el-button>
        <el-button :loading="addLoading" type="primary" @click.native="addSubmit"> 提交 </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="editFormVisible" :close-on-click-modal="false" title="编辑等级">
      <el-form ref="editForm" :model="editForm" label-width="100px">
        <el-input v-model="editForm.id" type="hidden" />
        <el-form-item label="等级">
          <el-input-number v-model="editForm.level" :min="1" :step="1" />
        </el-form-item>
        <el-form-item label="所需积分">
          <el-input-number v-model="editForm.needScore" :min="0" :step="10" />
        </el-form-item>
        <el-form-item label="称号">
          <el-input v-model="editForm.title" placeholder="可选，前台默认只展示 Lv.n" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.status" placeholder="请选择">
            <el-option :value="0" label="启用" />
            <el-option :value="1" label="禁用" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false"> 取消 </el-button>
        <el-button :loading="editLoading" type="primary" @click.native="editSubmit">
          提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

export default {
  name: "LevelConfig",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      recalcLoading: false,
      page: {},
      filters: {},

      addForm: { level: 1, needScore: 0, title: "", status: 0 },
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    list() {
      const me = this;
      me.listLoading = true;
      const params = Object.assign({}, me.filters, {
        page: me.page.page,
        limit: me.page.limit,
      });
      this.axios
        .form("/api/admin/level-config/list", params)
        .then((data) => {
          me.results = data.results;
          me.page = data.page;
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleAdd() {
      this.addForm = { level: 1, needScore: 0, title: "", status: 0 };
      this.addFormVisible = true;
    },
    addSubmit() {
      const me = this;
      this.axios
        .form("/api/admin/level-config/create", this.addForm)
        .then(() => {
          me.$message({ message: "提交成功", type: "success" });
          me.addFormVisible = false;
          me.list();
        })
        .catch((rsp) => {
          me.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    handleEdit(index, row) {
      const me = this;
      this.axios
        .get(`/api/admin/level-config/${row.id}`)
        .then((data) => {
          me.editForm = Object.assign({}, data);
          me.editFormVisible = true;
        })
        .catch((rsp) => {
          me.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    editSubmit() {
      const me = this;
      this.axios
        .form("/api/admin/level-config/update", me.editForm)
        .then(() => {
          me.list();
          me.editFormVisible = false;
        })
        .catch((rsp) => {
          me.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    handleRecalc() {
      const me = this;
      me.$confirm("将按当前积分重算全部用户等级，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          me.recalcLoading = true;
          return me.axios.form("/api/admin/level-config/recalc_levels", {});
        })
        .then((data) => {
          me.$message({
            message: `已更新 ${data && data.updated != null ? data.updated : 0} 名用户`,
            type: "success",
          });
        })
        .catch((rsp) => {
          if (rsp === "cancel" || rsp === "close") return;
          me.$notify.error({ title: "错误", message: (rsp && rsp.message) || "重算失败" });
        })
        .finally(() => {
          me.recalcLoading = false;
        });
    },
  },
};
</script>
